module.exports = __webpack_public_path__ + "static/media/fragetecken.f9b2311b.jpg";